import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";

export default function PendingApprovalViewModal() {
  const navigate = useNavigate();
  const [PendingStudents, setPendingStudents] = useState([]);
  const [PendingParents, setPendingParents] = useState([]);
  const [PendingTeachers, setPendingTeachers] = useState([]);
  const [Refresh, setRefresh] = useState(true);
  const [UserId, setUserId] = useState("");
  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);
  const [ActionTab, setActionTab] = useState(-1);
  const [IsLoading, setIsLoading] = useState(true);

  // Action Confirmation Start
  const [PendingDialog, setPendingDialog] = useState(false);

  const handleOpenPendingDialog = (id) => {
    setUserId(id);
    setPendingDialog(true);
  };

  const handleClosePendingDialog = async (del) => {
    setPendingDialog(false);
    if (del === true) {
      if (ActionTab === 1) {
        RejectUser(UserId);
      }
      if (ActionTab === 2) {
        ApproveUser(UserId);
      }
      setPendingDialog(false);
      setRefresh(!Refresh);
    }
  };
  // Action Confirmation End

  useEffect(() => {
    const fetchData = () => {
      if (schoolId) {
        GetPendingTeachers();
        GetPendingStudents();
        GetPendingParents();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [Refresh]);
  const GetPendingStudents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "student"),
      where("IsVerified", "==", 0),
      where("SchoolID", "==", schoolId)
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setPendingStudents([...tempArray]);
  };
  const GetPendingParents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "parent"),
      where("IsVerified", "==", 0),
      where("SchoolID", "==", schoolId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setPendingParents([...tempArray]);
  };
  const GetPendingTeachers = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "teacher"),
      where("IsVerified", "==", 0),
      where("SchoolID", "==", schoolId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setPendingTeachers([...tempArray]);
  };

  const ApproveUser = (uid) => {
    let DocRef = doc(db, "Users", uid);
    setDoc(
      DocRef,
      {
        IsVerified: 1,
      },
      { merge: true }
    );
    setRefresh(!Refresh);
  };

  const RejectUser = (uid) => {
    let DocRef = doc(db, "Users", uid);
    setDoc(
      DocRef,
      {
        IsVerified: 2,
      },
      { merge: true }
    ).then(() => {
      setRefresh(!Refresh);
    });
  };

  return {
    PendingStudents,
    PendingParents,
    PendingTeachers,
    GetPendingStudents,
    GetPendingParents,
    GetPendingTeachers,
    ApproveUser,
    RejectUser,
    PendingDialog,
    handleOpenPendingDialog,
    handleClosePendingDialog,
    ActionTab,
    setActionTab,
    IsLoading,
    navigate,
  };
}
